import { ErrorBoundary, setTag } from "@sentry/react";
import { FC, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Error from "../../Error";
import NotFound from "../../NotFound";
import UnderdotsRequest from "../UnderdotsRequest/UnderdotsRequest";
import UnderdotsShell from "../UnderdotsShell/UnderdotsShell";
import { ReCaptchaWrapper } from "../ReCaptchaWrapper/ReCaptchaWrapper";
import { useNewRelicCustomAttribute } from "../../../hooks/useNewRelic";

const PRODUCT_TAG = "underdots";

type UnderdotsPageProps = {};

const UnderdotsPage: FC<UnderdotsPageProps> = () => {
  useNewRelicCustomAttribute("product", PRODUCT_TAG);

  useEffect(() => {
    setTag(PRODUCT_TAG, true);
    return () => {
      setTag(PRODUCT_TAG, false);
    };
  }, []);

  return (
    <ErrorBoundary fallback={<Error />}>
      <ReCaptchaWrapper>
        <Routes>
          <Route path="/" element={<UnderdotsShell />}>
            <Route path="/request" element={<UnderdotsRequest />} />
            <Route path="/" element={<Navigate to="./request" />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ReCaptchaWrapper>
    </ErrorBoundary>
  );
};

export default UnderdotsPage;
